// Content data for Bridge of Hope Foundation website

export const heroData = {
  title: "Restoring Dignity, Delivering Hope",
  subtitle:
    "Bridging generosity with life-changing mobility support for vulnerable individuals and communities in need, wherever they are.",
  ctaPrimary: "Support the Mission",
  ctaSecondary: "See Our Work",
  heroImage: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca"
};

export const impactStats = [
  { number: "Compassion", label: "At the Heart of Our Work", icon: "Heart" },
  { number: "Partnership", label: "Working With Trusted Networks", icon: "Handshake" },
  { number: "Support", label: "Mobility & Assistive Equipment", icon: "Package" },
  { number: "Hope", label: "Delivered With Dignity", icon: "Users" }
];

export const programs = [
  {
    id: 1,
    title: "Equipment Collection",
    description:
      "We gather useful mobility and assistive equipment through donations, partnerships, and community support, helping prevent valuable items from going to waste.",
    image: "https://images.unsplash.com/photo-1619618691037-751d1e6c9ad1",
    icon: "Package"
  },
  {
    id: 2,
    title: "Shipment & Logistics",
    description:
      "We coordinate sorting, preparation, and safe shipment so equipment can move efficiently from places of generosity to places of need.",
    image: "https://images.unsplash.com/photo-1605732562742-3023a888e56e",
    icon: "Ship"
  },
  {
    id: 3,
    title: "Dignified Distribution",
    description:
      "We work with trusted local partners to help ensure equipment reaches individuals and communities in a respectful, practical, and meaningful way.",
    image: "https://images.unsplash.com/photo-1565615833231-e8c91a38a012",
    icon: "Heart"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Community Supporter",
    role: "Donor",
    content:
      "Bridge of Hope represents the kind of practical compassion that can truly change lives. I’m encouraged by the vision and the care behind the mission.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
  },
  {
    id: 2,
    name: "Partner Organisation",
    role: "Community Partner",
    content:
      "The focus on dignity, collaboration, and practical support makes this a mission with real long-term value for communities in need.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
  },
  {
    id: 3,
    name: "Volunteer Supporter",
    role: "Volunteer",
    content:
      "It’s inspiring to support a foundation that is building something thoughtful, inclusive, and genuinely useful for people who need mobility assistance.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Bridge of Hope Team",
    role: "Founding Leadership",
    bio:
      "Our leadership is committed to building a trustworthy, compassionate, and well-governed foundation that delivers practical support with dignity.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e"
  },
  {
    id: 2,
    name: "Trustee Opportunities",
    role: "Governance & Oversight",
    bio:
      "We are building a strong foundation with the support of people who value accountability, service, and long-term impact.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956"
  },
  {
    id: 3,
    name: "Operations & Partnerships",
    role: "Programme Support",
    bio:
      "We are developing trusted partnerships and practical systems to help equipment move efficiently from donors to communities in need.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
  },
  {
    id: 4,
    name: "Volunteer Network",
    role: "Community Engagement",
    bio:
      "Volunteers and supporters are a vital part of how Bridge of Hope will grow its reach, strengthen its mission, and serve with care.",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f"
  }
];

export const getInvolvedOptions = [
  {
    id: "donate",
    title: "Make a Donation",
    description:
      "Your financial support helps with collection, preparation, shipment, and practical delivery of mobility and assistive equipment.",
    icon: "Heart",
    cta: "Support the Mission",
    color: "green"
  },
  {
    id: "partner",
    title: "Become a Partner",
    description:
      "Churches, community groups, healthcare organisations, and businesses can partner with us through collections, sponsorship, referrals, or expertise.",
    icon: "Handshake",
    cta: "Partner With Us",
    color: "gold"
  },
  {
    id: "volunteer",
    title: "Volunteer Your Time",
    description:
      "Support our mission through collections, sorting, administration, fundraising, awareness, or other practical tasks.",
    icon: "Users",
    cta: "Volunteer",
    color: "green"
  },
  {
    id: "trustee",
    title: "Join as Trustee",
    description:
      "We welcome people with governance, finance, legal, charity, operations, or strategic experience who can help guide the foundation well.",
    icon: "Shield",
    cta: "Join as Trustee",
    color: "gold"
  }
];

export const milestones = [
  { year: "Vision", event: "Bridge of Hope Foundation established as a charitable initiative" },
  { year: "Planning", event: "Development of governance, partnerships, and operating model" },
  { year: "Launch", event: "Website, outreach, and engagement activities begin" },
  { year: "Growth", event: "Collection, logistics, and partnership systems expand" },
  { year: "Impact", event: "Mobility and assistive support reaches more communities in need" }
];

export const financialHighlights = [
  { label: "Transparency", value: "Committed" },
  { label: "Governance", value: "Developing Strong Oversight" },
  { label: "Stewardship", value: "Responsible Use of Resources" },
  { label: "Reporting", value: "Updates to Be Published" }
];

export const governanceDocs = [
  { title: "Governance Information", type: "Coming Soon", size: "-" },
  { title: "Safeguarding Policy", type: "Coming Soon", size: "-" },
  { title: "Data Protection Policy", type: "Coming Soon", size: "-" },
  { title: "Trustee Information", type: "Coming Soon", size: "-" },
  { title: "Annual Reports & Updates", type: "Coming Soon", size: "-" }
];

export const faqs = [
  {
    question: "What does Bridge of Hope Foundation do?",
    answer:
      "Bridge of Hope Foundation connects generosity with practical mobility and assistive support for individuals and communities in need."
  },
  {
    question: "Who do you serve?",
    answer:
      "We aim to support vulnerable individuals and communities who need mobility or assistive equipment, working through trusted and practical channels."
  },
  {
    question: "How can I help?",
    answer:
      "You can support Bridge of Hope by donating funds, partnering with us, volunteering your time, helping raise awareness, or expressing interest in trustee support."
  },
  {
    question: "Can I donate equipment?",
    answer:
      "Yes. As our collection processes develop, we plan to welcome suitable mobility and assistive equipment that can be used safely and meaningfully."
  },
  {
    question: "Is Bridge of Hope faith-based?",
    answer:
      "Our values are inspired by compassion, dignity, and service. We are publicly broad and inclusive, and our mission is to serve people from all backgrounds."
  },
  {
    question: "How will you ensure accountability?",
    answer:
      "We are committed to building strong governance, clear reporting, trusted partnerships, and responsible stewardship as the foundation grows."
  }
];

export const contactInfo = {
  email: "info@bridgeofhope.foundation",
  phone: "+44 0000 000000",
  whatsapp: "+44 0000 000000",
  address: {
    line1: "Bridge of Hope Foundation",
    line2: "Address details to be updated",
    city: "United Kingdom",
    postcode: "",
    country: "United Kingdom"
  },
  social: {
    facebook: "#",
    twitter: "#",
    instagram: "#",
    linkedin: "#"
  },
  charityNumber: "Pending"
};

export const donationAmounts = [
  { value: 25, label: "£25", impact: "Supports practical mission needs" },
  { value: 50, label: "£50", impact: "Helps with equipment handling and preparation" },
  { value: 100, label: "£100", impact: "Supports logistics and delivery activity" },
  { value: 250, label: "£250", impact: "Helps strengthen outreach and operational support" },
  { value: 500, label: "£500", impact: "Makes a meaningful contribution to mission delivery" },
  { value: "custom", label: "Custom Amount", impact: "Every gift helps make a difference" }
];